import actionTypes from 'SRC/modules/redux/actionTypes'

export const setPaginationParams = (params) => ({
  type: actionTypes.SET_PAGINATION_PARAMS,
  payload: params
})
